import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectDialogComponent } from './select-dialog.component';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { UzurvDirectivesModule } from '@uzurv/core';

@NgModule({
  imports: [CommonModule, FormsModule, MatDialogModule, MatInputModule, MatButtonModule, MatSelectModule, UzurvDirectivesModule],
  declarations: [SelectDialogComponent],
  exports: [SelectDialogComponent]
})
export class SelectDialogModule {}
